let resumeData = {
    "imagebaseurl":"https://github.com/RubenCastroCoding",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/sahil-patel-20b07a157/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/War-Nugget",
          "className":"fa fa-github"
        },
      ],
  }
  
  export default resumeData